import { useEffect, useRef } from "react";
import { useInView, useReducedMotion } from "framer-motion";

export const CountUp = ({ to, suffix = "", className = "", testId }) => {
    const ref = useRef(null);
    const inView = useInView(ref, { once: true, margin: "-40px" });
    const reduce = useReducedMotion();

    useEffect(() => {
        const el = ref.current;
        if (!el || !inView) return;
        if (reduce) {
            el.textContent = `${to}${suffix}`;
            return;
        }
        const start = performance.now();
        const dur = 1400;
        let raf;
        const tick = (now) => {
            const p = Math.min((now - start) / dur, 1);
            const eased = 1 - Math.pow(1 - p, 3);
            el.textContent = `${Math.round(to * eased)}${suffix}`;
            if (p < 1) raf = requestAnimationFrame(tick);
        };
        raf = requestAnimationFrame(tick);
        return () => cancelAnimationFrame(raf);
    }, [inView, to, suffix, reduce]);

    return (
        <span ref={ref} className={className} data-testid={testId}>
            0{suffix}
        </span>
    );
};
